import { useEffect, useRef } from 'react';

export const useEffectOnce = (effect: () => void, precondition = true) => {
  const hasRun = useRef(false);
  useEffect(() => {
    if (hasRun.current || !precondition) {
      return;
    }
    hasRun.current = true;

    effect();
  }, [effect, precondition]);
};
